import React from "react";
import { XCircle, Edit2, CheckCircle } from "lucide-react";
import ToolEditForm from "views/components/ToolEditForm";
import CategoryDropdown from "./CategoryDropdown";

const ToolDetailsModal = ({
    tool,
    isEditing,
    onClose,
    onEditClick,
    onSaveEdit,
    onCancelEdit,
    onApproveTool,
    onRejectTool,
    selectedCategoryId,
    selectedSubCategoryId,
    onCategoryChange,
    onSubCategoryChange,
    categories,
}) => {
    if (!tool) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-6">
                    <div className="flex justify-between items-start mb-6">
                        <h2 className="text-2xl font-bold">{tool.name}</h2>
                        <div className="flex gap-2">
                            <button
                                onClick={onClose}
                                className="text-gray-500 hover:text-gray-700"
                            >
                                <XCircle className="h-6 w-6" />
                            </button>
                        </div>
                    </div>

                    <div className="space-y-4">
                        {isEditing ? (
                            <ToolEditForm
                                tool={tool}
                                onSave={onSaveEdit}
                                onCancel={onCancelEdit}
                                categoryDropdown={
                                    <CategoryDropdown
                                        categories={categories}
                                        selectedCategoryId={selectedCategoryId}
                                        selectedSubCategoryId={
                                            selectedSubCategoryId
                                        }
                                        onCategoryChange={onCategoryChange}
                                        onSubCategoryChange={
                                            onSubCategoryChange
                                        }
                                    />
                                }
                            />
                        ) : (
                            <>
                                <div>
                                    <h3 className="font-medium text-gray-900">
                                        Description
                                    </h3>
                                    <p className="text-gray-600">
                                        {tool.description}
                                    </p>
                                </div>

                                <div>
                                    <h3 className="font-medium text-gray-900">
                                        Company
                                    </h3>
                                    <p className="text-gray-600">
                                        {tool.company}
                                    </p>
                                </div>

                                <div>
                                    <h3 className="font-medium text-gray-900">
                                        External URL
                                    </h3>
                                    <a
                                        href={tool.externalUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 hover:text-blue-700"
                                    >
                                        {tool.externalUrl}
                                    </a>
                                </div>

                                <div>
                                    <h3 className="font-medium text-gray-900">
                                        Tags
                                    </h3>
                                    <div className="flex flex-wrap gap-2 mt-2">
                                        {tool.tags?.map((tag) => (
                                            <span
                                                key={tag}
                                                className="px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-sm"
                                            >
                                                {tag}
                                            </span>
                                        ))}
                                    </div>
                                </div>

                                {tool.status === "Under Review" && (
                                    <div className="flex gap-4 mt-6">
                                        <button
                                            onClick={onEditClick}
                                            className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 flex items-center justify-center gap-2"
                                        >
                                            <Edit2 className="h-4 w-4" />
                                            Edit
                                        </button>
                                        <button
                                            onClick={() =>
                                                onApproveTool(tool.uuid)
                                            }
                                            className="flex-1 bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 flex items-center justify-center gap-2"
                                        >
                                            <CheckCircle className="h-4 w-4" />
                                            Approve
                                        </button>
                                        <button
                                            onClick={() =>
                                                onRejectTool(tool.uuid)
                                            }
                                            className="flex-1 bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 flex items-center justify-center gap-2"
                                        >
                                            <XCircle className="h-4 w-4" />
                                            Reject
                                        </button>
                                    </div>
                                )}
                                {tool.status === "Approved" && !isEditing && (
                                    <div className="flex gap-4 mt-6">
                                        <button
                                            onClick={onEditClick}
                                            className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 flex items-center justify-center gap-2"
                                        >
                                            <Edit2 className="h-4 w-4" />
                                            Edit
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ToolDetailsModal;
